<nav #navbarCommon class="navbar navbar-expand-lg navbar-light fixed-top bg-white">
  <div class="container">
      <img [src]="'assets/logos/logo.png'" width="120px" height="100%" class="d-inline-block align-top" alt="">
      <div class="text-center justify-content-center">
        <a class="d-inline-block nav-item nav-link">
          <img src="assets/flags/es.png" height="20" class="d-inline-block align-top" (click)="changeLanguage('es')" alt="">
        </a>
        <a class="d-inline-block nav-item nav-link">
          <img src="assets/flags/en.png" height="20" class="d-inline-block align-top" (click)="changeLanguage('en')" alt="">
        </a>
      </div>
  </div>
</nav>



<div class="container mt-5 pt-5">
  <div class="row">
    <div class="col">
      <h1>{{ "remittance.conditions.title" | translate}} </h1>
      <p>{{ "remittance.conditions.title_message_1" | translate}}</p>
      <p>{{ "remittance.conditions.title_message_2" | translate}}</p>
      <p>{{ "remittance.conditions.title_message_3" | translate}}</p>
      <hr>

      <ol>
        <li><p>{{ "remittance.conditions.overview_service" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.overview_service_a" | translate}}</li>
            <li>{{ "remittance.conditions.overview_service_b" | translate}}</li>
            <li>{{ "remittance.conditions.overview_service_c" | translate}}</li>
            <li>{{ "remittance.conditions.overview_service_d" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.definitions" | translate}} </p>
          <p>{{ "remittance.conditions.definitions_message" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.definitions_a" | translate}}</li>
            <li>{{ "remittance.conditions.definitions_b" | translate}}</li>
            <li>{{ "remittance.conditions.definitions_c" | translate}}</li>
            <li>{{ "remittance.conditions.definitions_d" | translate}}</li>
            <li>{{ "remittance.conditions.definitions_e" | translate}}</li>
            <li>{{ "remittance.conditions.definitions_f" | translate}}</li>
            <li>{{ "remittance.conditions.definitions_g" | translate}}</li>
            <li>{{ "remittance.conditions.definitions_h" | translate}}</li>
            <li>{{ "remittance.conditions.definitions_i" | translate}}</li>
            <li>{{ "remittance.conditions.definitions_j" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.accessing_service" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.accessing_service_a" | translate}}</li>
            <li>{{ "remittance.conditions.accessing_service_b" | translate}}</li>
            <li>{{ "remittance.conditions.accessing_service_c" | translate}}</li>
            <li>{{ "remittance.conditions.accessing_service_d" | translate}}</li>
            <li>{{ "remittance.conditions.accessing_service_e" | translate}}</li>
            <li>{{ "remittance.conditions.accessing_service_f" | translate}}</li>
            <li>{{ "remittance.conditions.accessing_service_g" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.payments" | translate}}</p>
          <p>{{ "remittance.conditions.payments_message" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.payments_a" | translate}}</li>
            <li>{{ "remittance.conditions.payments_b" | translate}}</li>
            <li>{{ "remittance.conditions.payments_c" | translate}}</li>
            <li>{{ "remittance.conditions.payments_d" | translate}}</li>
            <li>{{ "remittance.conditions.payments_e" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.transaction_payouts" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.transaction_payouts_a" | translate}}</li>
            <li>{{ "remittance.conditions.transaction_payouts_b" | translate}}</li>
            <li>{{ "remittance.conditions.transaction_payouts_c" | translate}}</li>
            <li>{{ "remittance.conditions.transaction_payouts_d" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.restrictions_conditions" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.restrictions_conditions_a" | translate}}</li>
            <li>{{ "remittance.conditions.restrictions_conditions_b" | translate}}</li>
            <li>{{ "remittance.conditions.restrictions_conditions_c" | translate}}</li>
            <li>{{ "remittance.conditions.restrictions_conditions_d" | translate}}</li>
            <li>{{ "remittance.conditions.restrictions_conditions_e" | translate}}</li>
            <li>{{ "remittance.conditions.restrictions_conditions_f" | translate}}</li>
            <li>{{ "remittance.conditions.restrictions_conditions_g" | translate}}</li>
            <li>{{ "remittance.conditions.restrictions_conditions_h" | translate}}</li>
            <li>{{ "remittance.conditions.restrictions_conditions_i" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.dispute_resolution" | translate}}</p>
          <p>{{ "remittance.conditions.dispute_resolution_message" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.dispute_resolution_a" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_b" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_c" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_d" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_e" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_f" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_g" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_h" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_i" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_j" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_k" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_l" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_m" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_n" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_o" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_p" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_q" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_r" | translate}}</li>
            <li>{{ "remittance.conditions.dispute_resolution_s" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.waiver_claims_governing_law" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.waiver_claims_governing_law_a" | translate}}</li>
            <li>{{ "remittance.conditions.waiver_claims_governing_law_b" | translate}}</li>
            <li>{{ "remittance.conditions.waiver_claims_governing_law_c" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.limitation_liability" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.limitation_liability_a" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.collection_information" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.collection_information_a" | translate}}</li>
            <li>{{ "remittance.conditions.collection_information_b" | translate}}</li>
            <li>{{ "remittance.conditions.collection_information_c" | translate}}</li>
            <li>{{ "remittance.conditions.collection_information_d" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.errors_problems" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.errors_problems_a" | translate}}</li>
            <li>{{ "remittance.conditions.errors_problems_b" | translate}}</li>
            <li>{{ "remittance.conditions.errors_problems_c" | translate}}</li>
            <li>{{ "remittance.conditions.errors_problems_d" | translate}}</li>
            <li>{{ "remittance.conditions.errors_problems_e" | translate}}</li>
            <li>{{ "remittance.conditions.errors_problems_f" | translate}}
                <p>{{ "remittance.conditions.errors_problems_f_1" | translate}}</p>
                <p>{{ "remittance.conditions.errors_problems_f_2" | translate}}</p>
                <p>{{ "remittance.conditions.errors_problems_f_3" | translate}}</p>
                <p>{{ "remittance.conditions.errors_problems_f_4" | translate}}</p>
                <p>{{ "remittance.conditions.errors_problems_f_5" | translate}}</p>
                <p>{{ "remittance.conditions.errors_problems_f_6" | translate}}</p>
                <p>{{ "remittance.conditions.errors_problems_f_7" | translate}}</p>
                <p>{{ "remittance.conditions.errors_problems_f_8" | translate}}</p>
                <p>{{ "remittance.conditions.errors_problems_f_9" | translate}}</p>
                <p>{{ "remittance.conditions.errors_problems_f_10" | translate}}</p>
            </li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.cancellation" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.cancellation_a" | translate}}</li>
            <p>{{ "remittance.conditions.cancellation_a_1" | translate}}</p>
            <p>{{ "remittance.conditions.cancellation_a_2" | translate}}</p>
            <p>{{ "remittance.conditions.cancellation_a_3" | translate}}</p>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.use_our_software" | translate}}</p>
          <p>{{ "remittance.conditions.use_our_software_message" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.use_our_software_a" | translate}}</li>
            <li>{{ "remittance.conditions.use_our_software_b" | translate}}</li>
            <li>{{ "remittance.conditions.use_our_software_c" | translate}}</li>
            <li>{{ "remittance.conditions.use_our_software_d" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.disclaimer_warranties" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.disclaimer_warranties_a" | translate}}</li>
            <li>{{ "remittance.conditions.disclaimer_warranties_b" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.indemnity" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.indemnity_a" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.miscellaneous" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.miscellaneous_a" | translate}}</li>
            <li>{{ "remittance.conditions.miscellaneous_b" | translate}}<a href="https://www.nmlsconsumeraccess.org/" target="_blank">{{ "remittance.conditions.miscellaneous_b_1" | translate}}</a></li>
            <li>{{ "remittance.conditions.miscellaneous_c" | translate}}</li>
            <li>{{ "remittance.conditions.miscellaneous_d" | translate}}</li>
            <li>{{ "remittance.conditions.miscellaneous_e" | translate}}</li>
            <li>{{ "remittance.conditions.miscellaneous_f" | translate}}</li>
            <li>{{ "remittance.conditions.miscellaneous_g" | translate}}</li>
            <li>{{ "remittance.conditions.miscellaneous_h" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.security_fraud_prevention" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.security_fraud_prevention_a" | translate}}</li>
          </ol>
        </li>
        <li><p>{{ "remittance.conditions.contact_information" | translate}}</p>
          <ol type="A">
            <li>{{ "remittance.conditions.contact_information_a" | translate}}</li>
          </ol>
        </li>
      </ol>
    </div>
  </div>
</div>

